<template>
  <div class="container-xxl">
    <titulo-grande texto="Minhas Contribuições" posicao="left" />

    <div class="alert alert-secondary" role="alert">
      <div class="row align-items-center">
        <input-money label="Valor mensal" tamanho="sm" classDiv="col-sm-4 col-md-3" nome="valor" ref="valor"
          v-model="dados.valor" />

        <InputSelect placeholder="" label="Quantidade de meses" :dados="dados_qtd_meses" tamanho="sm"
          classDiv="col-sm-5 col-md-3" name="qtd_meses" ref="qtd_meses" v-model="dados.qtd_meses" />

        <div class="col-sm-3 col-md-3 mb-3">
          <div class="col-12 bg-white px-3 py-1 rounded-1 text-center" style="font-size: .9rem;">
            Total
            <br>
            R$ {{ total_pagamenoto }}
          </div>
        </div>

        <InputSelect placeholder="" label="Forma de pagamento" :dados="dados_forma_pagamento" tamanho="sm"
          classDiv="col-sm-6 col-md-3" name="forma_pagamento" ref="forma_pagamento" v-model="dados.forma_pagamento" />

        <div class="col-sm-6 col-md-3 d-grid gap-2">
          <button class="btn btn-info btn-lg text-white mb-3" @click="carrega_pagamento()">Gerar pagamento</button>
        </div>
      </div>
    </div>

    <modal tituloModal="" @fecha_modal="fecha_modal" @hidden="fecha_modal" textoBtnChamada="Abrir qr-code pagamento"
      tamanho_modal="modal-md" :exibe_botao="true" id_modal="modal_qr" v-if="dadosPagamento.imagem">
      <template #default>
        <div class="row">
          <div class="col-md-10 offset-md-1">
            <img :src="'data:image/jpeg;base64,' + dadosPagamento.imagem" alt="" class="img imgthumbnail col-12">
          </div>
          <div class="col-12 text-break">
            {{ dadosPagamento.copia_cola }}
            <br><br>
            <button class="btn btn-sm btn-success" @click="copiar()" title="Copiar seu link de afiliado">Pagamento
              Copiar e cola
              <i class="bi bi-copy"></i></button>
          </div>
        </div>
      </template>
      <template #botaoPersonalizado>
        <fieldset>

        </fieldset>
      </template>
    </modal>

    <TabelaDatatable :dadosData="dadosData.dados" dadosAjax="" :columns="coluna"
      :ordem_tabela="[{ name: 'data_entrada', dir: 'desc' }]"
      :btnPersonalizado="{ btn: 'secondary', textoBtn: 'Ver indicações' }" @person_row="qtd_indicacao"
      :ativa_placeholder="ativa_placeholder">

    </TabelaDatatable>
  </div>
</template>

<script>
import TituloGrande from '@/components/TituloGrande.vue';
import TabelaDatatable from '@/components/TabelaDatatable.vue';
import { api } from '@/services/api'
import { AuthStore } from '@/stores/Auth';
import { toastr } from '@/plugins/toast';
import InputText from '@/components/form/InputText.vue';
import { copiar_texto, data_hoje } from '@/assets/js/functions';
import InputSelect from '@/components/form/InputSelect.vue';
import InputMoney from '@/components/form/InputMoney.vue';
import Modal from '@/components/Modal.vue';

export default {
  name: 'MinhasIndicacoes',
  data() {
    return {
      auth: AuthStore(),
      dadosData: {
        dados: [],
        filtro: { periodo: '' }
      },
      dadosPagamento: {
        imagem: ''
      },
      coluna: [
        { data: 'cod_transacao', title: 'Cód da Transação', width: '20%' },
        { data: 'data_pagamento', title: 'Data do pagamento', width: '20%' },
        { data: 'qtd_meses', title: 'Meses pagos', width: '15%' },
        { data: 'valor_mensal', title: 'Valor mensal', width: '15%' },
        { data: 'status_pagamento', title: 'Status', width: '15%' },
        { data: 'valor', title: 'Total', width: '10%' },
        // { data: 'expira_em', title: 'Data de expiração', width: '10%' },
      ],
      dados: {
        valor: "",
        qtd_meses: 1,
        forma_pagamento: 'pix',
      },
      dados_forma_pagamento: [
        { valor: 'pix', texto: 'Pix' },
        // { valor: 'creditcard', texto: 'Cartão de crédito' },
      ],
      dados_qtd_meses: [
        { valor: '1', texto: '1' },
        { valor: '2', texto: '2' },
        { valor: '3', texto: '3' },
        { valor: '6', texto: '6' },
        { valor: '9', texto: '9' },
        { valor: '12', texto: '12' },
        { valor: '24', texto: '24' },
        { valor: '36', texto: '36' },
      ],
      inicia_verificacao: false,
      ativa_placeholder: Boolean,
    }
  },
  components: {
    TituloGrande,
    TabelaDatatable,
    InputText,
    InputSelect,
    InputMoney,
    Modal,
  },
  computed: {
  },
  methods: {
    async carrega_lista_pagamento() {
      this.ativa_placeholder = true
      try {
        var dadosData = await api.post('finances/my_contributions', this.dados, { Authorization: this.auth.token })

        if (dadosData.status == 200) {
          this.dadosData = dadosData
        }

      } catch (error) {
        toastr.erro('Erro na requisição')
      }

      this.ativa_placeholder = false
    },
    async carrega_pagamento() {
      this.ativa_placeholder = true
      try {
        var dadosPagamento = await api.post('finances/payment', this.dados, { Authorization: this.auth.token })        
        if (dadosPagamento.status == 200) {
          this.dadosPagamento = dadosPagamento.dados
          this.verify_payment(this.dadosPagamento.resultado.id)
          setTimeout(() => {
            document.querySelector("#btn_modal_qr").click()
            this.carrega_lista_pagamento()
          }, 500);
        }else if (dadosPagamento.status >= 400) {
          toastr.erro(dadosPagamento.message)
          if(this.dados.valor < 10){
            this.dados.valor = '10.00'
          }
        }

      } catch (error) {
        toastr.erro('Erro na requisição')
      }

      this.ativa_placeholder = false
    },
    async verify_payment(id, repeat = 0) {
      try {
        this.inicia_verificacao = true;
        var countRepeat = 0
        while (this.inicia_verificacao) {
          if (repeat > 0 && countRepeat == repeat) {
            break;
          }
          await this.delay(10000)
          var verificaPagamento = await api.post('finances/verify_payment', { id: id }, { Authorization: this.auth.token })
          
          if (verificaPagamento.status == 200 && verificaPagamento.status_payment == 'approved') {
            this.ativa_placeholder = true
            toastr.sucesso("Pagamento aprovado com sucesso.");
            document.querySelector("#btn_close_modal_qr").click()
            this.limpa_dados()
            this.auth.renewToken();
            this.carrega_lista_pagamento()
            this.ativa_placeholder = false
          }else if (verificaPagamento.status == 401){
            toastr.erro(verificaPagamento.message)
          }
          countRepeat++;
        }
      } catch (error) {
        this.ativa_placeholder = false
        
        toastr.erro('Erro na requisição')
      }

    },
    async delay(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    async copiar() {
      var cp = await copiar_texto(this.dadosPagamento.copia_cola)
      if (cp) {
        toastr.sucesso("Link copiado com sucesso.")
      } else {
        toastr.erro("Não foi possivel copiar o link")
      }
    },
    limpa_dados() {
      this.dadosPagamento = {}
      this.dados = {
        valor: "10.00",
        qtd_meses: 1,
        forma_pagamento: 'pix',
      }
      this.inicia_verificacao = false
    }
  },
  computed: {
    total_pagamenoto: function () {
      return Number((this.dados.qtd_meses ? this.dados.qtd_meses : 1) * this.dados.valor).toLocaleString('pt-br', { minimumFractionDigits: 2 });
      // return Number((this.dados.qtd_meses ? this.dados.qtd_meses : 1) * this.dados.valor).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'});
    }
  },
  mounted() {
    this.carrega_lista_pagamento()
    this.dados.valor = '10.00'
    this.inicia_verificacao = false
  },
}
</script>

<style scoped></style>